<template lang="html">
  <Select
    v-model="localValue"
    :items="SortOrderItems"
    prepend-inner-icon="mdi-sort"
    item-value="sortOrder"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #item="{ item }">
      {{ item.sortOrder + 1 }} - {{ item[itemText] }}
    </template>
    <template #selection="{ item }">
      {{ item.sortOrder + 1 }} - {{ item[itemText] }}
    </template>
  </Select>
</template>

<script>
import localValue from '@/mixins/localValue';

export default {
  mixins: [localValue],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
      default: 'name',
    },
    serviceAction: {
      type: Function,
      required: false,
    }
  },
  data() {
    return {
      results: []
    };
  },
  created() {
    this.getResults();
  },
  computed: {
    SortOrderItems() {
      if (this.results.length > 0) {
        return this.results
      } else {
        return this.items
      }
    }
  },
  methods: {
    async getResults() {
      try {
        if (!this.serviceAction) return;
        const { data } = await this.serviceAction({
          page: { limit: 100 },
        });
        this.results = data;
      } catch (e) {
        console.log(e);
      }
    }
  },
};
</script>
